import * as lienStyles from '../../../styles/widgets/lien.module.scss';
import * as styleLink from '../../../styles/communs/polylink.module.scss';
import PropTypes from 'prop-types';

import {GatsbyImage, getImage} from 'gatsby-plugin-image';

import PolyLink from '../PolyLink';
import React from 'react';
import clsx from 'clsx';
import {altNN} from '../../../utils/parsing';

const Lien = ({
  elem,
  locale,
  column,
  row
}) => {
  const alt = locale === 'en' ? altNN(elem?.background?.alternativeTextEN) : altNN(elem?.background?.alternativeText);
  const {
    content,
    background,
    target_link,
    new_window,
    titleOrientation = 'CENTER',
    style,
    titleLink,
  } = elem;
  const divBloc = () => {

    return (
      <div
        className={target_link ?
          style !== 'FRAME'
        && !background ?
            clsx(lienStyles.bloc, lienStyles.noBackground)
            : clsx(lienStyles.bloc, lienStyles.background)
          : clsx(lienStyles.bloc)}
      >
        <div
          style={{
            paddingBottom: `calc((100% / ${column}) * (${row}))`,
            gridArea: '1 / 1 / -1 / -1'
          }}
        />
        {background ? (
          <GatsbyImage
            alt={altNN(alt)}
            className={lienStyles.image}
            image={getImage(background.imageFile)}
            style={{height: '100%', width: '100%'}}
          />
        ) : (<div className={lienStyles.emptyImage}></div>)}
        {style === 'FRAME' ? (
          <div className={lienStyles.mainBlocFrame}>
            <p className={clsx(lienStyles.h1, lienStyles.nbLines)}>
              {titleLink}
            </p>
          </div>
        ) : style === 'CTA' ? (
          <div className={lienStyles.mainBlocCta}>
            <div className={lienStyles.titleBlocCta}>
              <p className={clsx(lienStyles.h1, lienStyles.nbLines, styleLink.withoutIcon)}>
                {titleLink}
              </p>
            </div>
            <div className={lienStyles.contentBlocCta}>
              <p className={clsx(lienStyles.contentCta, lienStyles.h5ContentCta)}>
                {content}
              </p>
            </div>
          </div>
        ) : background ? (
          <div className={clsx({
            [lienStyles.mainBlocTop]: titleOrientation === 'TOP',
            [lienStyles.mainBlocBottom]: titleOrientation.includes('BOTTOM')
          }, lienStyles.mainBloc)}
          >
            <div className={lienStyles.containerTitle}>
              <div className={clsx({
                [lienStyles.contentTitleLeft]: titleOrientation.includes('LEFT'),
                [lienStyles.contentTitleRight]: titleOrientation.includes('RIGHT')
              }, lienStyles.contentTitle)}
              >
                <p className={lienStyles.h2}>
                  <span>
                    {titleLink}
                  </span>
                </p>
              </div>
            </div>
          </div>
        ) : (
          <div className={clsx({
            [lienStyles.mainBlocTop]: titleOrientation === 'TOP',
            [lienStyles.mainBlocBottom]: titleOrientation.includes('BOTTOM')
          }, lienStyles.mainBloc)}
          >
            <div className={clsx({
              [lienStyles.contentTitleLeft]: titleOrientation.includes('LEFT'),
              [lienStyles.contentTitleRight]: titleOrientation.includes('RIGHT')
            }, lienStyles.contentTitle)}
            >
              <p className={lienStyles.h3}>{titleLink}</p>
              {content &&
                <p className={clsx(lienStyles.nbLinesContent, lienStyles.h4)}>
                  {content}
                </p>
              }
            </div>
          </div>
        )}
      </div>
    );
  };

  if (target_link) {
    return (
      <PolyLink
        ariaLabel={titleLink}
        className={lienStyles.link}
        dataCy="lien-link"
        target={new_window ? '_blank' : ''}
        url={target_link}
      >
        {divBloc()}
      </PolyLink>
    );
  }
  // no link
  return divBloc();

};

Lien.propTypes = {
  column: PropTypes.number,
  elem: PropTypes.shape({
    content: PropTypes.string,
    elem: PropTypes.object,
    locale: PropTypes.string,
    style: PropTypes.oneOf(['DEFAULT', 'FRAME', 'CTA', 'NO_FRAME']),
    titleLink: PropTypes.string.isRequired,
    titleOrientation: PropTypes.oneOf([
      'CENTER',
      'TOP',
      'TOP_LEFT',
      'TOP_RIGHT',
      'TOP_CENTER',
      'BOTTOM',
      'BOTTOM_LEFT',
      'BOTTOM_RIGHT',
      'BOTTOM_CENTER'
    ]),
    target_link: PropTypes.string,
    background: PropTypes.object,
    new_window: PropTypes.bool,
  }),
  locale: PropTypes.string,
  row: PropTypes.number
};

export default Lien;
